import { useTranslation } from 'react-i18next';

import ProgressBar from '../../../../../../../../../shared/components/Globals/ProgressBar/ProgressBar';
import Spinner from '../../../../../../../../../shared/components/Globals/Spinner/Spinner';
import { TRANSLATIONS_QUOTES } from '../../../../../../../../../shared/translations/quotes';

export interface CensusProcessingStepProps {
  slowWarning: boolean;
}

export default function CensusProcessingStep({ slowWarning }: Readonly<CensusProcessingStepProps>) {
  const { t } = useTranslation();

  return (
    <div className="census-step census-step--processing">
      <div className="census-step__row">
        <Spinner size={20} variant="svg" />
        <div className="census-status-label">
          {slowWarning
            ? t(TRANSLATIONS_QUOTES.create.censusModal.processingSlow)
            : t(TRANSLATIONS_QUOTES.create.censusModal.processingNormal)}
        </div>
      </div>
      <ProgressBar
        variant="indeterminate"
        ariaLabel={
          slowWarning
            ? t(TRANSLATIONS_QUOTES.create.censusModal.processingSlow)
            : t(TRANSLATIONS_QUOTES.create.censusModal.processingNormal)
        }
      />
      <output className="census-callout census-callout--success">
        <span aria-hidden="true">✓ </span>
        {t(TRANSLATIONS_QUOTES.create.censusModal.processingSuccessDesc)}
      </output>
    </div>
  );
}
